import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Listbox } from '@headlessui/react';
import { useCategoryStore } from '../../../../store/category';
export default function AttributeSelect({ attribute, updateVariantValues }) {
    const filter = useCategoryStore((state) => state.filter.attributes);
    const setFilter = useCategoryStore((state) => state.setFilter);
    const valueAttribute = filter.find((item) => item.id === attribute.id);
    let selectedValue = valueAttribute?.values[0];
    let value = attribute.values.find((item) => item.id === selectedValue);
    return (_jsx(Listbox, { value: selectedValue ?? '', onChange: (val) => {
            value = attribute.values.find(item => item.id === val);
            setFilter({ selectedValue: { attribute, value }, replace: true });
            updateVariantValues(attribute, value);
        }, children: ({ open }) => (_jsxs("div", { className: "react-custom-select attribute-select", children: [_jsxs(Listbox.Button, { children: [value && value.value, _jsx("span", { className: open ? 'opened' : 'closed' })] }), _jsx(Listbox.Options, { children: attribute.values.map((value, i) => {
                        return (_jsx(Listbox.Option, { value: value.id, children: ({ active, selected }) => _jsx("div", { className: `item ${selected ? 'selected' : ''}`, children: value.value }) }, `attribute-${attribute.id}-value-${value.id}`));
                    }) })] })) }));
}
